import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  CalendarIconSvg,
  GoingButtonBackgroundSvg,
  InterestedButtonBackgroundSvg,
  LocationIconSvg,
} from '../../Pages/frightUI/frightEventSVG/Svg.js'
import Buttons from '../../Pages/frightUI/ButtonComponent.js'
import { ProfileApis } from '../../API/Login/ProfileApi'
import { useSelector } from 'react-redux'
import moment from 'moment'
import {
  clickedOnGoingButton,
  clickedOnInterestedButton,
  clickedOnNotGoingButton,
  clickedOnNotInterestedButton,
  clickedOnNotSaveButton,
  clickedOnSaveButton,
  handleDeletePost,
} from '../../Pages/frightUI/EventActions'
import StarRating from './Star.jsx'
import DeleteModal from './DeleteModal.jsx'
import { CONSTANT } from '../../Constants/EventService'
import EventVideoPlayer from './EventVideoPlayer.jsx'

const ListCard = ({
  item,
  setToasts,
  handleIndividualEventImages,
  eventCategory,
  UpdateCallback,
  handleChangeTab,
  page
}) => {
  const { frProUser } = useSelector((state) => state.Users)
  const [isProfileImageLoading, setProfileImageLoading] = useState(false)
  const [hostProfileImg, setHostProfileImg] = useState()
  const [isModalOpen, setModalOpen] = useState(false)
  const [isSaveLoading, SetIsSaveLoading] = useState(false)
  const [isInterestedLoading, SetIsInterestedLoading] = useState(false)
  const [isGoingLoading, SetIsGoingLoading] = useState(false)
  const [isDeleteLoading, SetIsDeleteLoading] = useState(false)
  // Parse the times into moment objects, assuming they are in HH:mm format
  const startTime = moment(item?.startTime || item?.eventStartTime, 'HH:mm')
  const endTime = moment(item?.endTime || item?.eventEndTime, 'HH:mm')
  // Calculate the difference in milliseconds
  const duration = moment.duration(endTime.diff(startTime))
  // Get hours and minutes from the duration
  const hours = duration.hours()
  const minutes = duration.minutes()
  console.log('-----item---->123456yyyyyy', item)
  console.log('-----page---->123456yyyyyy', page)
  const getHostProfile = () => {
    setProfileImageLoading(true)
    // const userObj = {
    //   fre8ProAccessToken: frProUser?.fre8ProAccessToken,
    //   userId: item?.createdByUserId,
    //   clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    // }
    // ProfileApis.GetProfileImageByUserId(userObj)
    let reqObj = {
      fre8ProAccessToken: frProUser?.fre8ProAccessToken,
      userId: item?.createdByUser || item?.createdByUserId,
      businessId: null,
      profileId: null,
      clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    };
    // Fetch user personal details
    ProfileApis.getUserPersonalDetailsByUserId(reqObj)
      .then((res) => {
        setHostProfileImg(res?.data)
      })
      .catch((error) => {
        console.error(error)
        // let customMessage = 'Profile Images loading  failed'
        // let type = 'Couch Services'
        // let color = 'red'
        // ErrorHandle(error, setToasts, customMessage, type, color)
      })
      .finally(() => {
        setProfileImageLoading(false)
      })
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }
  const handleEventDeletion = (eventId) => {
    SetIsDeleteLoading(true)
    let reqObj = {
      fre8ProAccessToken: frProUser.fre8ProAccessToken,
      eventId: eventId,
      clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    }
    handleDeletePost(reqObj, SetIsDeleteLoading, setToasts, UpdateCallback)
  }

  useEffect(() => {
    getHostProfile()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return (
    <div className="meetup shadow-sm p-4 rounded-4 bg-white mt-3">
      <div className="d-flex align-items-center mb-3">
        <div className="flex-shrink-0">
          {isProfileImageLoading ? (
            <img
              src="/images/video_avatar.png"
              className="placeholder-wave round-profileImg"
              alt="guestImage"
            />
          ) : (
            <img
              className="img-fluid round-profileImg"
              src={hostProfileImg?.profileImageUrlList?.length > 0 ? hostProfileImg?.profileImageUrlList?.at(-1) : '/images/video_avatar.png'}
              // src={hostProfileImg ? hostProfileImg : 'images/video_avatar. 
              alt="user img"
            />
          )}
        </div>
        <div className="flex-grow-1 ms-3">
          <h3 className="mb-0">{hostProfileImg?.userId === (item?.createdByUser || item?.createdByUserId) && hostProfileImg?.fullNameOfTheUser}</h3>
        </div>
        <div className="d-flex align-items-center">
          {eventCategory === 'posted' && (
            <>
              <Link className="me-2" to={{ pathname: `/pro/editFreightEvent/${item?.eventId}` }} state={item}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none">
                  <path
                    d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                    stroke="#005A70"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"></path>
                </svg>
              </Link>
              <Buttons
                type="submit"
                className="p-0 me-2"
                onClick={() => {
                  setModalOpen(true)
                }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none">
                  <path
                    d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
                    stroke="#005A70"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"></path>
                </svg>
              </Buttons>
            </>
          )}
          {eventCategory !== 'saved' &&
            (item?.createdByUser || item?.createdByUserId) !== frProUser?.userId && (
              <button
                title={`${eventCategory === 'saved' ? 'UnSave' : 'Save'}`}
                type="submit"
                disabled={isSaveLoading}
                className="send me-2 p-0"
                data-fdprocessedid="rkas2m"
                onClick={() => {
                  SetIsSaveLoading(true)
                  let reqObj = {
                    fre8ProAccessToken: frProUser.fre8ProAccessToken,
                    eventId: item?.eventId,
                    userId: frProUser?.userId,
                    clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
                  }
                  if (eventCategory === 'saved') {
                    clickedOnNotSaveButton(
                      reqObj,
                      SetIsSaveLoading,
                      setToasts,
                      UpdateCallback
                    )
                    return
                  }
                  clickedOnSaveButton(reqObj, SetIsSaveLoading, setToasts)
                }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill={eventCategory === 'saved' ? ` #FDB022ed` : 'none'}>
                  <path
                    d="M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"></path>
                </svg>
              </button>
            )}
          <DeleteModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            onDelete={handleEventDeletion}
            eventId={item?.eventId}
            loading={isDeleteLoading}
          />
          <div className="dropdown">
            <button
              type="submit"
              className="p-0"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 4 16"
                fill="none">
                <path
                  d="M1.66634 8.5C2.12658 8.5 2.49967 8.1269 2.49967 7.66667C2.49967 7.20643 2.12658 6.83333 1.66634 6.83333C1.2061 6.83333 0.833008 7.20643 0.833008 7.66667C0.833008 8.1269 1.2061 8.5 1.66634 8.5Z"
                  stroke="#98A2B3"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"></path>
                <path
                  d="M1.66634 2.66667C2.12658 2.66667 2.49967 2.29357 2.49967 1.83333C2.49967 1.3731 2.12658 1 1.66634 1C1.2061 1 0.833008 1.3731 0.833008 1.83333C0.833008 2.29357 1.2061 2.66667 1.66634 2.66667Z"
                  stroke="#98A2B3"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"></path>
                <path
                  d="M1.66634 14.3333C2.12658 14.3333 2.49967 13.9602 2.49967 13.5C2.49967 13.0398 2.12658 12.6667 1.66634 12.6667C1.2061 12.6667 0.833008 13.0398 0.833008 13.5C0.833008 13.9602 1.2061 14.3333 1.66634 14.3333Z"
                  stroke="#98A2B3"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"></path>
              </svg>
            </button>

            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <a className="dropdown-item" href="#">
                  <span className="me-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none">
                      <path
                        d="M6 14.6666V7.99992H10V14.6666M2 5.99992L8 1.33325L14 5.99992V13.3333C14 13.6869 13.8595 14.026 13.6095 14.2761C13.3594 14.5261 13.0203 14.6666 12.6667 14.6666H3.33333C2.97971 14.6666 2.64057 14.5261 2.39052 14.2761C2.14048 14.026 2 13.6869 2 13.3333V5.99992Z"
                        stroke="#344054"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"></path>
                    </svg>
                  </span>
                  Share to my feed
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <span className="me-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none">
                      <g clipPath="url(#clip0_4399_3949)">
                        <path
                          d="M11.3332 14V12.6667C11.3332 11.9594 11.0522 11.2811 10.5521 10.781C10.052 10.281 9.37375 10 8.6665 10H3.33317C2.62593 10 1.94765 10.281 1.44755 10.781C0.947456 11.2811 0.666504 11.9594 0.666504 12.6667V14M15.3332 14V12.6667C15.3327 12.0758 15.1361 11.5018 14.7741 11.0349C14.4121 10.5679 13.9053 10.2344 13.3332 10.0867M10.6665 2.08667C11.2401 2.23353 11.7485 2.56713 12.1116 3.03487C12.4747 3.50261 12.6717 4.07789 12.6717 4.67C12.6717 5.26211 12.4747 5.83739 12.1116 6.30513C11.7485 6.77287 11.2401 7.10647 10.6665 7.25333M8.6665 4.66667C8.6665 6.13943 7.4726 7.33333 5.99984 7.33333C4.52708 7.33333 3.33317 6.13943 3.33317 4.66667C3.33317 3.19391 4.52708 2 5.99984 2C7.4726 2 8.6665 3.19391 8.6665 4.66667Z"
                          stroke="#344054"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_4399_3949">
                          <rect width="16" height="16" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Share on my story
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <span className="me-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none">
                      <g clipPath="url(#clip0_4399_3949)">
                        <path
                          d="M11.3332 14V12.6667C11.3332 11.9594 11.0522 11.2811 10.5521 10.781C10.052 10.281 9.37375 10 8.6665 10H3.33317C2.62593 10 1.94765 10.281 1.44755 10.781C0.947456 11.2811 0.666504 11.9594 0.666504 12.6667V14M15.3332 14V12.6667C15.3327 12.0758 15.1361 11.5018 14.7741 11.0349C14.4121 10.5679 13.9053 10.2344 13.3332 10.0867M10.6665 2.08667C11.2401 2.23353 11.7485 2.56713 12.1116 3.03487C12.4747 3.50261 12.6717 4.07789 12.6717 4.67C12.6717 5.26211 12.4747 5.83739 12.1116 6.30513C11.7485 6.77287 11.2401 7.10647 10.6665 7.25333M8.6665 4.66667C8.6665 6.13943 7.4726 7.33333 5.99984 7.33333C4.52708 7.33333 3.33317 6.13943 3.33317 4.66667C3.33317 3.19391 4.52708 2 5.99984 2C7.4726 2 8.6665 3.19391 8.6665 4.66667Z"
                          stroke="#344054"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_4399_3949">
                          <rect width="16" height="16" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Share to buddy profile
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <span className="me-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none">
                      <g clipPath="url(#clip0_4399_3957)">
                        <path
                          d="M6.6668 8.66673C6.9531 9.04948 7.31837 9.36618 7.73783 9.59535C8.1573 9.82452 8.62114 9.9608 9.0979 9.99495C9.57466 10.0291 10.0532 9.9603 10.501 9.79325C10.9489 9.62619 11.3555 9.36477 11.6935 9.02673L13.6935 7.02673C14.3007 6.39805 14.6366 5.55604 14.629 4.68205C14.6215 3.80807 14.2709 2.97202 13.6529 2.354C13.0348 1.73597 12.1988 1.38541 11.3248 1.37781C10.4508 1.37022 9.60881 1.7062 8.98013 2.31339L7.83347 3.45339M9.33347 7.33339C9.04716 6.95064 8.68189 6.63394 8.26243 6.40477C7.84297 6.17559 7.37913 6.03931 6.90237 6.00517C6.4256 5.97102 5.94708 6.03981 5.49924 6.20687C5.0514 6.37393 4.64472 6.63534 4.3068 6.97339L2.3068 8.97339C1.69961 9.60207 1.36363 10.4441 1.37122 11.3181C1.37881 12.1921 1.72938 13.0281 2.3474 13.6461C2.96543 14.2641 3.80147 14.6147 4.67546 14.6223C5.54945 14.6299 6.39146 14.2939 7.02013 13.6867L8.16013 12.5467"
                          stroke="#344054"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_4399_3957">
                          <rect width="16" height="16" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Copy link
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="meetttxt d-flex gap-4">
        <div className="meeth text-center">
          <h2 className="mb-0">{moment(item.startDate).format('DD')}</h2>
          <h4>{moment(item.endDate).format('MMM')}</h4>
        </div>
        <div className="meetup-im flex-shrink-0 clr d-flex align-items-center justify-content-center rounded-3">
          <div
            className="eventslider mb-2"
            style={{
              overflow: 'hidden',
              height: 314,
              width: 210,
              position: 'relative',
            }}>
            {item?.eventMediaList?.length > 1 && (
              <div className="position-absolute topright text-end w-100 p-1 z-index align-items-bottom bottom-0">
                <button
                  className="addmore "
                  style={{ marginBottom: '1rem' }}
                  data-bs-toggle="modal"
                  data-bs-target="#gallerymodalpopup"
                  onClick={() => {
                    handleIndividualEventImages(item?.eventMediaList)
                  }}>
                  +{item?.eventMediaList?.length - 1}
                </button>{' '}
              </div>
            )}

            <div style={{ height: 314, width: 210, display: 'flex' }}>
              {item?.eventMediaList[0]?.mediaType === "IMAGE" ?
                <img src={item?.eventMediaList[0]?.mediaUrl} alt={item?.originalFileName} /> : <EventVideoPlayer media={item?.eventMediaList[0]} />}
            </div>
          </div>
        </div>
        <div className="mettxt w-100">
          <div className="meettile d-flex justify-content-between">
            <Link to={{ pathname: `/pro/FreightEventsDetail/${item?.eventId}` }} state={item}>
              {item?.eventName}
            </Link>
          </div>
          <div className="meet-date my-3">
            <div className="meet-date my-3">
              <div className="flx d-flex ">
                <div className="flex-shrink-0">
                  <CalendarIconSvg />
                </div>
                <div className="flex-grow-1 ms-2">
                  <p className="mb-3">
                    {moment(item.startDate || item.eventStartDate).format('ddd')} {item?.startTime || item?.eventStartTime} -{' '}
                    {item?.endTime || item?.eventEndTime} {hours !== 0 && <span>{hours} hours</span>}
                    {minutes !== 0 && <span>{minutes} minutes</span>}
                  </p>
                </div>
              </div>
              <div className="flx d-flex ">
                <div className="flex-shrink-0">
                  <LocationIconSvg />
                </div>
                <div className="flex-grow-1 ms-2">
                  <p className="mb-0">{`${item?.eventLocation || item?.location}`}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="meetp">
            <p>{item?.eventDescription}</p>
          </div>
          {eventCategory === 'saved' &&
            (isSaveLoading ? (
              <button className="btn btn-secondary my-button" disabled={isSaveLoading}>
                <div className="loader-custom"></div>
              </button>
            ) : (
              <button
                className="btn custom-button2 rounded-3 border btntext"
                data-fdprocessedid="rkas2m"
                onClick={() => {
                  SetIsSaveLoading(true)
                  let reqObj = {
                    fre8ProAccessToken: frProUser.fre8ProAccessToken,
                    eventId: item?.eventId,
                    userId: frProUser?.userId,
                  }
                  clickedOnNotSaveButton(
                    reqObj,
                    SetIsSaveLoading,
                    setToasts,
                    UpdateCallback
                  )
                }}>
                UnSave
              </button>
            ))}
          {eventCategory !== 'past' &&
            eventCategory !== 'saved' &&
            item?.createdByUser !== frProUser?.userId && (
              <div className="meetup-btn goingButton" id="Allgoing">
                {eventCategory !== 'interested' &&
                  (isGoingLoading ? (
                    <button
                      className="btn btn-secondary my-button"
                      disabled={isGoingLoading}>
                      <div className="loader-custom"></div>
                    </button>
                  ) : (
                    <button
                      disabled={isGoingLoading}
                      className={`${eventCategory === 'going'
                        ? 'btn custom-button2 rounded-3 border btntext'
                        : ''
                        }`}
                      onClick={() => {
                        SetIsGoingLoading(true)
                        let reqObj = {
                          fre8ProAccessToken: frProUser.fre8ProAccessToken,
                          eventId: item?.eventId,
                          userId: frProUser?.userId,
                          clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
                        }
                        if (eventCategory === 'going') {
                          clickedOnNotGoingButton(
                            reqObj,
                            SetIsGoingLoading,
                            setToasts,
                            UpdateCallback
                          )
                          return
                        }
                        clickedOnGoingButton(reqObj, SetIsGoingLoading, setToasts)
                      }}>
                      {eventCategory === 'going' ? (
                        <span>Not going</span>
                      ) : (
                        <GoingButtonBackgroundSvg />
                      )}
                    </button>
                  ))}
                {eventCategory !== 'going' &&
                  (isInterestedLoading ? (
                    <button
                      className="btn btn-secondary my-button"
                      disabled={isInterestedLoading}>
                      <div className="loader-custom"></div>
                    </button>
                  ) : (
                    <button
                      id="Allgoing"
                      disabled={isInterestedLoading}
                      className={`${eventCategory === 'interested'
                        ? 'btn custom-button2 rounded-3 border btntext'
                        : ''
                        }`}
                      onClick={() => {
                        SetIsInterestedLoading(true)
                        let reqObj = {
                          fre8ProAccessToken: frProUser.fre8ProAccessToken,
                          eventId: item?.eventId,
                          userId: frProUser?.userId,
                          clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
                        }
                        if (eventCategory === 'interested') {
                          clickedOnNotInterestedButton(
                            reqObj,
                            SetIsInterestedLoading,
                            setToasts,
                            UpdateCallback
                          )
                          return
                        }
                        clickedOnInterestedButton(
                          reqObj,
                          SetIsInterestedLoading,
                          setToasts
                        )
                      }}>
                      {eventCategory === 'interested' ? (
                        <span>Not interested</span>
                      ) : (
                        <InterestedButtonBackgroundSvg />
                      )}
                    </button>
                  ))}
              </div>
            )}

          {eventCategory === 'past' && (
            <div className="d-flex align-items-center gap-3 mt-4 d-none">
              <button
                disabled
                style={{ backgroundColor: '#005a70', opacity: '0.7' }}
                className="btn custom-button2 rounded-3 border btntext ">
                Cancel
              </button>
              <span style={{ color: '#005a70' }} className="fw-bold">
                Rate your experience
              </span>
              <StarRating totalStars={5} />
            </div>
          )}
        </div>
        <div className="w-16 text-center">
          {/* <p
            style={
              item?.eventState === 'ACTIVE'
                ? { color: 'blue' }
                : item?.eventState === 'CANCELLED'
                ? { color: 'red' }
                : {}
            }>
            {item?.eventState}
          </p> */}
          {item?.eventState === 'ACTIVE' && !item?.pastEvent && (
            <div className={`meetup-active`}>
              <button className="rounded-4 acceptbtn px-2">{item?.eventState}</button>
            </div>
          )}
          {item?.eventState === 'CANCELLED' && !item?.pastEvent && (
            <button className="rounded-4 requsted-btn text-danger">
              {item?.eventState}
            </button>
          )}
          {item?.pastEvent && (
            <div className={`meetup-active`}>
              <button className="rounded-4 requsted-btn px-2">
                Past {CONSTANT.EVENT}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

ListCard.propTypes = {
  item: PropTypes.object,
  categoryLabel: PropTypes.string,
  setToasts: PropTypes.func,
  handleIndividualEventImages: PropTypes.func,
  eventCategory: PropTypes.string,
  UpdateCallback: PropTypes.func,
  handleChangeTab: PropTypes.func,
  page: PropTypes.number,
}
export default ListCard